import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { useGSAP } from '@gsap/react';
import LenisProvider from './src/providers/LenisProvider';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0);
  });
};

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  window.scrollTo(0, 0);
  setTimeout(() => {
    window.scrollTo(0, 0);
    ScrollTrigger.refresh();
  }, 100);
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => {
  return [0, 0];
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return (
    <LenisProvider>
      {element}
      <Analytics />
      <SpeedInsights />
    </LenisProvider>
  );
};
